export default "__VITE_ASSET__BEjd6jsj__"